import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './BenefitsSection.module.scss'

type Benefit = { title: string; desc: string }

const ICONS = ['🛣️', '🚙', '🛏️', '🍳', '🔥', '⛺']

export const BenefitsSection: React.FC = () => {
    const { t } = useTranslation()
    const items = t('benefits.items', { returnObjects: true }) as Benefit[]

    return (
        <PageSection
            title={t('benefits.title')}
            align="start"
            style={{ backgroundColor: 'var(--bg-base)' }}
        >
            <div className={cls.grid}>
                {items.map((b, idx) => (
                    <div key={idx} className={cls.card}>
                        <div className={cls.iconWrap}>{ICONS[idx] ?? '✦'}</div>
                        <p className={cls.title}>{b.title}</p>
                        <p className={cls.desc}>{b.desc}</p>
                    </div>
                ))}
            </div>
        </PageSection>
    )
}

export default BenefitsSection
